import * as AnnouncementActions from '../actions/create.actions';
import { defaultAnnouncementForm } from '../../constants';

const initialState = {
  submitting: false,
  submitSuccess: false,
  announcementForm: defaultAnnouncementForm,
  error: null,
  message: '',
};

const create = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case AnnouncementActions.CREATE_ANNOUNCEMENT:
      return { ...state, submitting: true, submitSuccess: false, error: null };
    case AnnouncementActions.CREATE_ANNOUNCEMENT_SUCCESS:
      return { ...state, submitting: false, submitSuccess: true };
    case AnnouncementActions.CREATE_ANNOUNCEMENT_FAIL:
      return { ...state, submitting: false, submitSuccess: false, message: payload.message, error: payload.error };
    case AnnouncementActions.CLEAR_ANNOUNCEMENT_CREATE_FORM:
      return initialState;
    case AnnouncementActions.CHANGE_ANNOUNCEMENT_CREATE_FORM:
      return { ...state, announcementForm: { ...state.announcementForm, ...payload.data } };
    default:
      return state;
  }
};

export default create;
